var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 71,
    viewBox: "0 0 68 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.717 0.893639C15.0189 1.38977 0.0136719 16.7029 0.0136719 35.5208C0.0136719 54.3386 15.0189 69.6518 33.717 70.1479V0.893639Z",
    fill: "#616870"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7168 70.1477C52.4149 69.6516 67.4201 54.3384 67.4201 35.5206C67.4201 16.7028 52.4149 1.3896 33.7168 0.893471V70.1477Z",
    fill: "#4B5158"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5981 58.4534V58.4634L19.4209 38.4854L33.5981 46.8611V46.8653L33.6016 46.8611L47.7871 38.4854L33.6016 58.4634L33.5981 58.4534Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4414 35.762L33.9217 29.3644L33.9217 29.3633L33.9228 29.3639L33.9239 29.3634L33.9239 29.3644L47.732 35.8234L47.7784 35.796L33.6015 12.2725L33.5982 12.2838V12.2725L19.4414 35.762Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.c78c609bfa44fcb5e695c0900dc69fae.svg";
export { ForwardRef as ReactComponent };